
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
interface IGraficoPerfil{

  id: string
  total: number
  internos: number
  externos: number
  // contratados: number
  // naoContratados: number
}

export const GraficoPerfilInterno: React.FC<IGraficoPerfil> = ({ id, externos, internos, total }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        // {
        //   name: 'Total perfis',
        //   data: [total, internos, externos]
        // },
        {
          name: 'Internos',
          data: [internos]
        },
        {
          name: 'Externos',
          data: [externos]
        }
      ],

      chart: {
        type: 'bar',
        stacked: true,
        height: 450,
        width: 405
      },

      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: true,
              offsetX: 0,
              style: {
                fontSize: '12px',
                fontWeight: 900
              }
            }

          }
        }
      },
      title: {
        text: 'Perfil candidatos'
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: number) {
          return val.toString()
        },
        offsetY: 0,
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },
      xaxis: {
        categories: ['Candidatos']
      },
      yaxis: {
        title: {
          text: undefined
        }
      },

      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [total, externos, internos])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
